var map = {
	"./b2b_logo.svg": "hAaR",
	"./b2b_logo_white.svg": "NqEN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "It/d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/b2b_logo.*\.svg$
// module id = It/d
// module chunks = 18